// @flow
import React from 'react';
import type { SocialContent } from 'types/SocialContent';
import { getTimeDifference } from 'utils/dateUtils';
import Label from 'components/fragments/text/Label';
import { getDateFromString } from 'utils/dateUtils';

type Props = {
  content: SocialContent,
  transparent?: boolean,
  onClick: Function
};

const FacebookCard = (props: Props) => {
  const { backgroundImage, description, comments, likes, share } = props.content;
  const date = getDateFromString(props.content.date);

  return (
    <a
      href={`https://www.facebook.com/${props.content.id}`}
      onClick={props.onClick}
      className="box card card--social"
      title="Voir ce contenu sur Facebook"
      style={{ opacity: props.transparent ? 0.3 : 1 }}
      target="_blank"
      rel="noreferrer noopener">
      {backgroundImage ? (
        <div className="card__thumbnail" style={{ backgroundImage: `url(${backgroundImage})` }} />
      ) : null}
      <div className="card__body">
        <p className="card__desc ft-secondary" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
      <div className="card__footer ft-h6">
        <div className="card__stat">
          <span>
            <i className="icon icon-coment-fb" />
            {comments}
          </span>
          <span>
            <i className="icon icon-like-fb" />
            {likes}
          </span>
          <span>
            <i className="icon icon-share" />
            {share}
          </span>
        </div>
        <span className="ft-up">{`${getTimeDifference(new Date(), date)}`}</span>
      </div>
      <div className="card__social">
        <Label isBlue icon="icon-facebook" />
      </div>
    </a>
  );
};

export default FacebookCard;
